import React, { useState } from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import StockImagesSearch from '../../../common/StockImagesSearch';
import MediaPickersConstants from '../../../MediaPickersConstants';
import ImageElementStockImagesOrientationSelect from './ImageElementStockImagesOrientationSelect';

const ImageElementStockImagesSearch = (props) => {
    const [contextMenuAnchor, setContextMenuAnchor] = useState(undefined);

    const {
        imageElementStockImagesOrientation,
        imageElementStockImagesSearchValue, setProperty, clearImageElementStockImages, imageElementStockImages,
        imageElementStockImagesSearching, searchImageElementStockImages, loadDefaultImageElementStockImages
    } = props;

    const disableClearButton = imageElementStockImagesSearchValue === "" &&
        imageElementStockImagesOrientation === MediaPickersConstants.STOCK_MEDIA_ORIENTATION.ALL_ORIENTATIONS &&
        imageElementStockImages.length === MediaPickersConstants.STOCK_IMAGES_PER_PAGE;

    const onSearchValueChange = (event) => {
        setProperty('imageElementStockImagesSearchValue', event.target.value);
    };

    const loadImageStockImages = (orientation) => {
        setProperty('imageElementStockImagesSearching', true);
        searchImageElementStockImages(imageElementStockImagesSearchValue, (orientation || imageElementStockImagesOrientation), 1, MediaPickersConstants.STOCK_IMAGES_PER_PAGE, () => {
            setProperty('imageElementStockImagesSearching', false);
        });
    };

    const clearResults = () => {
        setProperty('imageElementStockImagesSearchValue', '');

        const needClearOnlyInput = imageElementStockImagesSearchValue !== "" &&
            imageElementStockImages.length === MediaPickersConstants.STOCK_IMAGES_PER_PAGE;

        if (!needClearOnlyInput) {
            clearImageElementStockImages();
            loadDefaultImageElementStockImages();
        }
    };

    const onOrientationChange = (orientation) => {
        setContextMenuAnchor(undefined);
        loadImageStockImages(orientation);
    };

    return (
        <StockImagesSearch
            clearResults={clearResults}
            disableClearButton={disableClearButton}
            searchValue={imageElementStockImagesSearchValue}
            isSearching={imageElementStockImagesSearching}
            onSearchValueChange={onSearchValueChange}
            onSearchValueSubmit={loadImageStockImages}
            setContextMenuAnchor={setContextMenuAnchor}
            contextMenuAnchor={contextMenuAnchor}
            stockImageOrientationSelect={<ImageElementStockImagesOrientationSelect onOrientationChange={onOrientationChange} />}
        />
    );
};

const mapStateToProps = (state) => {
    const {
        imageElementStockImagesSearchValue,
        imageStockImagesSearchValue,
        imageElementStockImagesSearching,
        imageStockImagesSearching,
        imageElementStockImagesOrientation,
        imageStockImagesOrientation,
        imageElementStockImages,
        imageStockImages
    } = state.mediaPicker;

    return {
        imageElementStockImagesSearchValue: imageElementStockImagesSearchValue ?? imageStockImagesSearchValue ?? '',
        imageElementStockImagesSearching: imageElementStockImagesSearching ?? imageStockImagesSearching ?? false,
        imageElementStockImagesOrientation: imageElementStockImagesOrientation ?? imageStockImagesOrientation ?? MediaPickersConstants.STOCK_MEDIA_ORIENTATION.ALL_ORIENTATIONS,
        imageElementStockImages: imageElementStockImages || imageStockImages || []
    };
};

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const clearImageElementStockImages = () => dispatch(mediaPickerActions.clearImageElementStockImages());
    const searchImageElementStockImages = (keywords, orientation, pageNumber, itemsPerPage, callback) =>
        dispatch(mediaPickerActions.searchImageElementStockImages(keywords, orientation, pageNumber, itemsPerPage, callback));
    const loadDefaultImageElementStockImages = () => dispatch(mediaPickerActions.loadDefaultImageElementStockImages());

    return {
        setProperty,
        clearImageElementStockImages,
        searchImageElementStockImages,
        loadDefaultImageElementStockImages
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageElementStockImagesSearch);
